import React from 'react';
import { Control } from 'react-hook-form';
import { Col, Row } from 'reactstrap';
import { CandidateDto } from '../../../../services/applicant_tracking/CandidateService/CandidateDto';
import { MultiAttachmentInputFormField } from '../../../../components/MultiAttachmentInputFormField';

interface PropTypes {
  control: Control<CandidateDto>;
}

export function CandidateDocumentsInput(props: PropTypes) {
  return (
    <Row>
      <Col xs={6}>
        <MultiAttachmentInputFormField<CandidateDto>
          control={props.control}
          controller={{
            mainController: 'documents',
            id: 'id',
            content: 'content',
            fileName: 'filename',
            size: 'size',
          }}
          fieldName={'Documents'}
          allowedFormats={['.pdf', '.doc', '.docx']}
          maxFileSizeMb={10}
          maxFilesSizeMb={20}
          maxTotalFiles={6}
          isRequired={false}
          disabled={false}
        />
      </Col>
    </Row>
  );
}
